if (!customElements.get('byte-product-list-tabs')) {
  class ByteProductListTabs extends HTMLElement {
    connectedCallback() {
      this.tablist = this.querySelector('[role="tablist"]');
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];

      this.boundClick = this.#onClick.bind(this);
      this.boundKeydown = this.#onKeydown.bind(this);

      this.tablist?.addEventListener('click', this.boundClick);
      this.tablist?.addEventListener('keydown', this.boundKeydown);
    }

    disconnectedCallback() {
      this.tablist?.removeEventListener('click', this.boundClick);
      this.tablist?.removeEventListener('keydown', this.boundKeydown);
    }

    #onClick(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab || !this.tabs.includes(tab)) return;

      this.#activate(this.tabs.indexOf(tab));
    }

    #onKeydown(event) {
      const current = document.activeElement;
      if (!current || current.getAttribute('role') !== 'tab' || !this.tabs.includes(current)) return;

      const index = this.tabs.indexOf(current);
      let next = index;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        next = (index + 1) % this.tabs.length;
        event.preventDefault();
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        next = (index - 1 + this.tabs.length) % this.tabs.length;
        event.preventDefault();
      } else if (event.key === 'Home') {
        next = 0;
        event.preventDefault();
      } else if (event.key === 'End') {
        next = this.tabs.length - 1;
        event.preventDefault();
      } else {
        return;
      }

      this.#activate(next);
      this.tabs[next]?.focus();
    }

    #activate(index) {
      const tab = this.tabs[index];
      if (!tab) return;

      this.tabs.forEach((t, i) => {
        const selected = i === index;
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
        t.setAttribute('tabindex', selected ? '0' : '-1');
        t.classList.toggle('is-active', selected);
      });

      this.panels.forEach((panel, i) => {
        const active = i === index;
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      tab.scrollIntoView({
        inline: 'nearest',
        block: 'nearest',
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });

      const root = this.closest('[data-testid="product-list"]');
      const header = root?.querySelector('.section-resource-list__header');
      if (!header) return;

      const title = tab.dataset.collectionTitle;
      const url = tab.dataset.collectionUrl;

      if (title) {
        const heading = header.querySelector('h1, h2, h3, h4, h5, h6');
        if (heading) heading.textContent = title;
      }

      if (url) {
        const link = header.querySelector('a[href*="/collections/"]');
        if (link) link.setAttribute('href', url);
      }
    }
  }

  customElements.define('byte-product-list-tabs', ByteProductListTabs);
}
